import { createFileRoute, redirect } from "@tanstack/react-router";

import { localizePath } from "@/lib/locale";
import { getLocale } from "@/paraglide/runtime.js";

/**
 * Where business pages used to live. Printed QR codes, old emails and saved links still say
 * `/t/<slug>/...`, so each one moves for good to the same page at the root (ADR 0032), sub-page
 * and query included.
 */
export const Route = createFileRoute("/(public)/t/$")({
  beforeLoad: ({ params, location }) => {
    throw redirect({
      href: `${localizePath(`/${params._splat ?? ""}`, getLocale())}${location.searchStr}`,
      statusCode: 301,
    });
  },
});
